export enum RetriesEnum {
  FiveTimes = 5
}

export enum IntervalEnum {
  OneSecond = 1000
}
